module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAAAXNSR0IArs4c6QAAARdJREFUWAnFmA0OgyAMhT2GO8Zu4wF2Wb2LyS6wsFcDiRIo/REhaWC0fd9DzRY3hRBmxAfxmh4axIrMecJiRdDYEe/eHogRWZjCSgY2WsXR1QQYZzghNzKQb3YxwXLY5A33RKQvKjKYUemqigVmTHqmpoIZl46rGWa8/cd5rCLWvsJF1J/kVnhyJBWV1iVd1dwSb+VVsFpxDVLbr+m49guwL/Yo0ujyNX4xDVL+2/EcPDkBcUH8Ejmul5TvOgM27goU4M89AwX48cDV9m+9DS1IK+8yIxWX1qnMaEW19awZq5i172LGK+LqdzWfjmHSMTWdoPlSpacqzknMZ5GuqIiBtFKsPptsKSvyVQ4Sw98Nh78dD/1/4A/3xRrqk1BCQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/close_2x.png
// module id = 1706
// module chunks = 0